<template>
  <span class="custom-file__download-pic">
    <icon
      data="@icon/download.svg"
      :fill="true"
      width="var(--icon-24)"
      height="var(--icon-24)"
      class="custom-file__download-icon"
      color="var(--monochrome05to04)"
    />
  </span>
</template>

<script setup lang="ts">
/**
 * Shared file download glyph used by file rows that reveal download actions on hover.
 */
</script>
